import { z } from 'zod'
import { FIELD_CANNOT_BE_EMPTY } from '../../../../consts/validationErrors'
import { ProjectStageEnum, ProjectTypeEnum } from '../../../../consts/projectTypeOptions'

export const descriptionSchema = z
  .object({
    name: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(240, { message: "Максимум 240 символов" }),
    type: z
      .string({ required_error: FIELD_CANNOT_BE_EMPTY })
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .pipe(z.nativeEnum(ProjectTypeEnum)),
    stage: z.nativeEnum(ProjectStageEnum, { required_error: FIELD_CANNOT_BE_EMPTY }),
    region: z
      .string({ required_error: FIELD_CANNOT_BE_EMPTY })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY }),
    description: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
    full_description: z
      .string()
      .trim()
      .superRefine((s, ctx) => {
        if (s.length === 0) return
        if (s.length < 2) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Минимально 2 символа",
          })
        }
        if (s.length > 2000) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Максимум 2000 символов",
          })
        }
      })
      .default(''),
    env_factor: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
    expected_result: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
    initial_state: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
    necessary_actions: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
    implementation: z
      .string({
        required_error: FIELD_CANNOT_BE_EMPTY,
      })
      .trim()
      .min(1, { message: FIELD_CANNOT_BE_EMPTY })
      .min(2, { message: "Минимально 2 символа" })
      .max(500, { message: "Максимум 500 символов" }),
  })

export type DescriptionSchemaType = z.infer<typeof descriptionSchema>